/**
 * Outcome of a single planned-invoice item processed inside an `InvoiceRun`.
 *
 * - `PENDING` — created with the run, not yet processed.
 * - `SUCCESS` — a draft `PatientInvoice` was assembled; `patientInvoiceId`
 *   is set. (Issuing-on-run is slice 3; in slice 1 SUCCESS = draft created.)
 * - `SKIPPED` — re-validation at processing time disqualified the planned
 *   invoice (e.g. the units were consumed by a concurrent per-patient
 *   invoice in the interim), the run was canceled, or the run was orphaned.
 *   `skipReason` is set to one of the `InvoiceRunSkipReason` values.
 * - `FAILED` — an exception escaped during processing; `errorMessage` is set.
 *   FAILED items do NOT promote the parent InvoiceRun to FAILED.
 */
export var InvoiceRunItemStatus;
(function (InvoiceRunItemStatus) {
    InvoiceRunItemStatus["PENDING"] = "pending";
    InvoiceRunItemStatus["SUCCESS"] = "success";
    InvoiceRunItemStatus["SKIPPED"] = "skipped";
    InvoiceRunItemStatus["FAILED"] = "failed";
})(InvoiceRunItemStatus || (InvoiceRunItemStatus = {}));
//# sourceMappingURL=invoice-run-item-status.enum.js.map